export default "__VITE_ASSET__CL1A_X_X__"